import React, { useState, useEffect, useRef } from 'react';
import MaskedInput from 'react-text-mask';
import TextField from 'pencil/TextField';
import Grid from 'pencil/Grid';
import { makeStyles } from 'pencil/styles';
import * as I18n from 'circe/I18n';
import { useDispatch } from 'redux-react-hook';

const useStyles = makeStyles((theme) => ({
  error: {
    marginTop: 5,
  },
}));

const TextMaskCustomNumbers = (props) => {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      mask={[/[0-9٠-٩]/, /[0-9٠-٩]/, /[0-9٠-٩]/, /[0-9٠-٩]/]}
      placeholderChar={'\u2000'}
      showMask
      guide={false}
      ref={(ref) => {
        inputRef(ref ? ref.inputElement : null);
      }}
    />
  );
};

const TextMaskCustomChars = (props) => {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      mask={[/[a-zA-Z\u0600-\u06FF]/, ' ', /[a-zA-Z\u0600-\u06FF]/, ' ', /[a-zA-Z\u0600-\u06FF]/]}
      placeholderChar={'\u2000'}
      showMask
      guide={false}
      ref={(ref) => {
        inputRef(ref ? ref.inputElement : null);
      }}
    />
  );
};

const LicensePlate = (props) => {
  const {
    change, propertyName, input, meta, initialValue,
  } = props;
  const dispatch = useDispatch();
  const classes = useStyles();

  const [firstPart, setFirstPart] = useState('');
  const [secondPart, setSecondPart] = useState('');
  const [showPlaceHolder, setShowPlaceHolder] = useState(false);

  const firstPartInputRef = useRef();
  const secondPartInputRef = useRef();

  useEffect(() => {
    const fullLicensePlate = `${firstPart} ${secondPart}`.toUpperCase();
    dispatch(change(propertyName, fullLicensePlate));
    if (firstPart && secondPart) {
      input.onChange(fullLicensePlate);
    }
  }, [firstPart, secondPart]);

  useEffect(() => {
    if (initialValue) {
      const [firstPartValue, ...restParts] = initialValue.split(' ');
      setFirstPart(firstPartValue);
      setSecondPart(restParts.join(' '));
    }
  }, [initialValue]);

  const handleFirstPartChange = (event) => {
    setFirstPart(event.target.value);
  };

  const handleSecondPartChange = (event) => {
    setSecondPart(event.target.value);
  };

  const moveFocusToSecondPart = () => {
    if (firstPartInputRef.current.value.length === 4) {
      secondPartInputRef.current.focus();
      setShowPlaceHolder(true);
    } else {
      setShowPlaceHolder(false);
    }
  };

  return (
    <Grid container spacing={1}>
      <Grid item xs={12} sm={6} md={6}>
        <TextField
          fullWidth
          value={firstPart.toUpperCase()}
          onChange={handleFirstPartChange}
          onKeyUp={moveFocusToSecondPart}
          label={I18n.str('licensePlate', 'License Plate')}
          placeholder={I18n.str('enterFirstPart', 'First part (e.g., 1234)')}
          InputProps={{
            inputComponent: TextMaskCustomNumbers,
            inputRef: firstPartInputRef,
          }}
          FormHelperTextProps={{ classes: { root: classes.error } }}
          error={meta.touched && typeof meta.error !== 'undefined'}
          helperText={meta.touched && meta.error ? meta.error : null}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={6}>
        <TextField
          fullWidth
          value={secondPart.toUpperCase()}
          onChange={handleSecondPartChange}
          placeholder={showPlaceHolder && I18n.str('enterSecondPart', 'Second part (e.g., A A A)')}
          InputProps={{
            inputComponent: TextMaskCustomChars,
            inputRef: secondPartInputRef,
          }}
        />
      </Grid>
    </Grid>
  );
};

export default LicensePlate;
